// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3GWiJ","left":"InfoRow_left__Z9lQR"};